import axios from "axios";
import { gateway } from "../../api";

const apiUrl = gateway;

export function approveStudent(data) {
  return axios.post(`${apiUrl}/student/approve`, data);
}